<template>
	<div style="width: 100%;height: 100%;">
		<div style="width: 100%;background-color: #fff;">
			<EducationHeader />
			<div style="overflow: hidden;">
				<div class="bannerBox">
					<a-carousel :dot-position="bottom" autoplay>
						<div class="bannerImg" v-for="(item, index) in bannerData" :key="index">
							<img :src="getImg(item.imageUrl)" />
						</div>
					</a-carousel>
				</div>
				<div class="industrialBox">
					<div class="industrialTitleBox">
						<div class="industrialTitle">
							产业智库
						</div>
						<div class="MoreBox" @click="goMore('/educationService/components/thinktank', { type: '产业智库' })">
							更多 ></div>
					</div>
					<div class="industrialContentBox">
						<div class="industrialContent">
							<div class="industrialContentLeft">
								<a-carousel arrows autoplay :dots="false" :slides-to-show="1">
									<template #prevArrow>
										<div class="lef" style="display: none;" />
									</template>
									<template #nextArrow>
										<div class="rig" style="display: none;" />
									</template>
									<div class="imgBox" style="width: 100%;height: 226px" v-for="item in zhiku" :key="item.id">
										<img v-if="item.thinkTankLogo" :src="getImg(item.thinkTankLogo)" alt="">
										<img v-else src="@/assets/img/defaultImg.png" alt="">
									</div>
								</a-carousel>
							</div>
							<div class="industrialContentRight">
								<a-carousel effect="fade" autoplay>
									<div v-for="item in zhiku" :key="item.id">
										<div class="industrialContentTitle">
											<dict-render :dict-obj="dictObjs['thinktank_type']" v-if="item.thinkTankType"
												:text="item.thinkTankType"></dict-render>
										</div>
										<div class="industrialContentDesc">{{ item.thinkTankName }}</div>
										<div class="industrialContentInfo ellipsis3">{{ item.title }}</div>
										<div class="industrialContentBtn">
											<a-button class="btn" ghost type="primary"
												@click="goMore('/educationService/components/thinktankDetail', { type: '产业智库', id: item.id })">查看详情</a-button>
										</div>
									</div>
								</a-carousel>
							</div>
						</div>
					</div>
				</div>
				<div class="smallBanner">
					<img src="@/assets/img/eduSmallBanner.png" alt="">
				</div>
				<div class="recruitmentBox">
					<div class="recruitmentTitleBox">
						<div class="recruitmentTitle">
							科研助理招聘
						</div>
						<div class="MoreBox" @click="goMore('/EducationService/components/recruitment', { type: '科研助理招聘' })">更多 >
						</div>
					</div>
					<div class="recruitmentContentBox">
						<div class="recruitmentSmallBox">
							<div class="recruitmentSmallInfo" v-for="(item, index) in recruitmentData" :key="index"
								@click="goMore('/educationService/components/recruitmentDetail', { type: '科研助理招聘', id: item.companyCode })">
								<div class="recruitmentBottomBox">
									<div class="recruitmentBottomTopBox">
										<img v-if="item.companyLogo" :src="getImg(item.companyLogo)" alt="">
										<img v-else src="@/assets/img/userPhoto.jpg" alt="">
									</div>
									<div class="recruitmentBottomMiddleBox">{{ item.companyName }}
										<div class="recruitmentBottomRightBottom"></div>
									</div>
									<div class="recruitmentBottomBottomBox">
										<dict-render :dict-obj="dictObjs['businessScope']" v-if="item.businessScope"
											:text="item.businessScope"></dict-render> | <dict-render :dict-obj="dictObjs['projecttype']"
											v-if="item.companyProperty" :text="item.companyProperty"></dict-render> | {{ item.registerMoney }}元
									</div>
									<div class="recruitmentBottomBoxBtn"
										@click="goMore('/educationService/components/recruitmentDetail', { type: '科研助理招聘', id: item.companyCode })">
										<a-button class="btn" type="primary">申请职位</a-button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="talentBox">
					<div class="talentLeftBox">
						<div class="talentTitleBox">
							<div class="talentTitle">
								人才求职
							</div>
							<div class="MoreBox" @click="goMore('/educationService/components/findpeople', { type: '找人才' })">更多 ></div>
						</div>
						<div class="talentContentBox">
							<div class="talentSmallBox">
								<div class="talentSmallLeft">
									<img src="@/assets/img/eduLeftImg.png" alt="">
								</div>
								<div class="talentSmallright">
									<div class="talentSmallContent">
										<div class="card" v-for="item in findPeopleList" :key="item.id"
											@click="goMore('/educationService/components/findpeopleDetail', { type: '找人才', id: item.id })">
											<div class="titleName">{{ item.title }}</div>
											<div class="info">
												<p>咨询电话：{{ item.telephone }}</p>
												<p>报名时间：{{ item.startDate }} ~ {{ item.endDate }}</p>
												<p>招聘地址：{{ item.webAddress }}</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="talentRightBox">
						<div class="talentTitleBox">
							<div class="talentTitle">
								创业导师
							</div>
							<div class="MoreBox"
								@click="goMore('/EducationService/components/entrepreneurshipMentor', { type: '创业导师' })">更多
								></div>
						</div>
						<div class="talentContentBox">
							<div class="talentSmallBox" v-for="(item, index) in teacherData" :key="index">
								<div class="teacherName">
									{{ item.name }}&nbsp; / &nbsp;<dict-render :dict-obj="dictObjs['education_background']"
										v-if="item.educationBackground" :text="item.educationBackground"></dict-render>
								</div>
								<div class="teacherInfo">
									<div style="margin: 10px 0 5px 0;">职称：<dict-render :dict-obj="dictObjs['professionalTitle']"
											v-if="item.professionalTitle" :text="item.professionalTitle"></dict-render></div>
									<div class="teacherResearch">研究领域：<dict-render :dict-obj="dictObjs['research_field']"
											v-if="item.researchArea" :text="item.researchArea"></dict-render></div>
									<div class="askBtn">
										<a-button type="primary" ghost
											@click="goMore('/educationService/components/entrepreneurshipMentorDetail', { type: '创业导师', id: item.userId })">查看详情</a-button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- <div style="width: 100%;background-color: #ecf0f6;">
					<div class="linkBox">
						<div class="linkLeft">友情链接</div>
						<div class="linkRight">
							<div class="linkRightItem" v-for="(item, index) in LinkData " :key="index">{{ item }}</div>
						</div>
					</div>
				</div> -->
			</div>
		</div>
		<LayoutFooter />
	</div>
</template>

<script>
import { platformName } from "@/config/platformConfig";
import LayoutFooter from '@/layout/layoutPage/footer/LayoutFooterNew2';
import EducationHeader from './components/educationHeader';
import { homeEducationInfo, entrepreneurshipMentor } from '@/api/educationService';
import { file_service } from "@/api/adminService";
import { dictMixin } from "@/mixins";
import DictRender from '@/components/other/DictRender';
import { getBannerInfo } from "@/api/homeService";

export default {
	name: "index",
	mixins: [dictMixin],
	components: {
		LayoutFooter,
		EducationHeader,
		DictRender
	},
	data() {
		return {
			dictNames: 'businessScope,projecttype,education_background,professionalTitle,research_field,thinktank_type',
			platformName,
			current: ['sy'],
			clickMenuTitle: '',
			formState: {
				user: null,
			},
			formSearchBox: {
				city: null,
				company: null,
				project: null,
				demand: null
			},
			recruitmentData: [],
			teacherData: [],
			findPeopleList: [],
			zhiku: [],
			bannerData: []
		}
	},
	created() {
		this.getJobList()
		this.getZhikuList()
		this.getTutorList()
		this.getFindPeople()
		this.getBannerList()
	},
	methods: {
		goMore(url, params) {
			this.$router.push({
				path: url,
				query: params
			})
		},
		menuClick(e) {
			this.clickMenuTitle = e.item.title
		},
		backhome() {
			this.$router.push('/')
		},
		getImg(imgUrl) {
			return file_service.imagesWeb(imgUrl)
		},
		getJobList() {
			this.getAction({
				url: homeEducationInfo.jobPageList,
				params: { pageNum: 1, pageSize: 8 }
			}).then(res => {
				this.recruitmentData = res.records
			})
		},
		getZhikuList() {
			this.getAction({
				url: homeEducationInfo.zhikuList,
				params: {}
			}).then(res => {
				this.zhiku = res.records
			})
		},
		getTutorList() {
			this.getAction({
				url: entrepreneurshipMentor.pageList,
				params: { pageNum: 1, pageSize: 4 }
			}).then(res => {
				this.teacherData = res.records
			})
		},
		getFindPeople() {
			this.getAction({
				url: homeEducationInfo.findpeopleList,
				params: { pageNum: 1, pageSize: 4 }
			}).then(res => {
				this.findPeopleList = res.records
			})
		},
		getBannerList() {
			this.getAction({
				url: getBannerInfo.pageList,
				params: { type: 'education' }
			}).then(res => {
				this.bannerData = res.records.reverse()
			})
		},
	}
}
</script>

<style scoped lang="less">
.smallHeaderBox {
	overflow: hidden;
	width: 100%;
	background-color: #ecf0f6;
	color: #666666;
	font-size: 14px;
	padding: 10px 0;

	.smallHeader {
		float: left;
	}

	.backhome {
		float: right;
		cursor: pointer;
		color: #1890ff;
	}
}

.headerBox {
	width: 100%;
	height: 92px;
	background-color: #fff;

	.hearderContentBox {
		overflow: hidden;
		width: 1200px;
		margin: 0 auto;

		.titleBox {
			float: left;
			line-height: 92px;
			font-size: 30px;
			font-weight: bold;
			color: #035aea;
		}

		.rightBox {
			float: right;
			margin-top: 2.5%;
		}
	}
}

.menuTopBox {
	margin: 0 auto;
	width: 1200px;
	background-color: #fff;

	.menuTopContent {
		margin: 0 auto;

		:deep(.ant-menu-horizontal:not(.ant-menu-dark)>.ant-menu-item) {
			width: 14%;
			text-align: center;
		}

		:deep(.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-selected) {
			background-color: #1d72ff;
			color: #fff;
		}

		:deep(.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-selected::after) {
			border: none;
		}
	}
}

.bannerBox {
	position: relative;
	width: 100%;

	:deep(.ant-carousel) {
		position: relative;
		width: 100%;
	}

	.bannerImg {
		width: 100%;
		height: 282px;

		img {
			width: 100%;
			object-fit: cover;
			height: 280px;
		}
	}
}


.smallBanner {
	margin: 10px auto 20px auto;
	width: 1200px;
	height: 120px;

	img {
		width: 100%;
		height: 100%;
	}
}

.industrialBox {
	width: 1200px;
	margin: 20px auto;

	.industrialTitleBox {
		overflow: hidden;
		width: 100%;
		padding: 15px 0 8px 0;
		border-bottom: 1px solid #dedede;

		.industrialTitle {
			float: left;
			font-size: 20px;
			color: #333;
		}

		.industrialTitle::before {
			content: '';
			padding-left: 12px;
			border-left: 4px solid #035aea;
		}

		.MoreBox {
			float: right;
			color: #999;
			font-size: 14px;
			cursor: pointer;
		}
	}

	.industrialContentBox {
		overflow: hidden;
		padding: 20px 10px;

		.industrialContent {
			overflow: hidden;
			width: 100%;

			.industrialContentLeft {
				float: left;
				width: 35%;
				height: 226px;

				.lef {
					display: none !important;
					background-image: url('../../assets/img/jianlef.png');
					background-repeat: no-repeat;
					background-size: 100% 100%;
					z-index: 1;
					width: 2rem;
					left: 0;
					height: 2rem;
					border-radius: 50%;
				}

				.lef:hover {
					background-image: url('../../assets/img/jianlefh.png');
					background-repeat: no-repeat;
					background-size: 100% 100%;
					z-index: 1;
					border-radius: 50%;
				}

				.rig {
					display: none !important;
					background-image: url('../../assets/img/jianrig.png');
					background-repeat: no-repeat;
					background-size: 100% 100%;
					z-index: 1;
					width: 2rem;
					right: 0;
					height: 2rem;
					border-radius: 50%;
				}

				.rig:hover {
					background-image: url('../../assets/img/jianrigh.png');
					background-repeat: no-repeat;
					background-size: 100% 100%;
					z-index: 1;
					border-radius: 50%;
				}

				.imgBox {
					cursor: pointer;
					width: 35%;
					height: 226px;

					img {
						width: 100%;
						height: 100%;
						object-fit: cover;
					}
				}
			}

			.industrialContentLeft:hover {
				.lef {
					display: block !important;
				}

				.rig {
					display: block !important;
				}
			}

			.industrialContentRight {
				position: relative;
				// overflow: hidden;
				float: right;
				width: 63%;
				color: #333;
				height: 226px;

				.industrialContentTitle {
					font-size: 20px;
					font-weight: bold;
					margin-bottom: 20px;
				}

				.industrialContentDesc {
					margin: 8px 0;
					font-size: 18px;
					text-overflow: ellipsis;
					-o-text-overflow: ellipsis;
					overflow: hidden;
					white-space: nowrap;
				}

				.industrialContentInfo {
					margin: 8px 0 40px 0;
					font-size: 14px;
					color: #666;
					min-height: 60px;
				}

				.industrialContentBtn {
					width: 120px;
					height: 35px;
					z-index: 999;

					.btn {
						width: 100%;
						height: 100%;
					}
				}
			}
		}
	}
}

.recruitmentBox {
	width: 1200px;
	margin: 20px auto;

	.recruitmentTitleBox {
		overflow: hidden;
		width: 100%;
		padding: 15px 0 8px 0;
		border-bottom: 1px solid #dedede;

		.recruitmentTitle {
			float: left;
			font-size: 20px;
			color: #333;
		}

		.recruitmentTitle::before {
			content: '';
			padding-left: 12px;
			border-left: 4px solid #035aea;
		}

		.MoreBox {
			float: right;
			color: #999;
			font-size: 14px;
			cursor: pointer;
		}
	}

	.recruitmentContentBox {
		padding: 14px 0;
		width: 100%;

		.recruitmentSmallBox {
			display: flex;
			align-items: center;
			justify-content: flex-start;
			flex-wrap: wrap;
			padding: 12px 0;
			width: 100%;

			.recruitmentSmallInfo {
				width: 22%;
				border: 1px solid #dedede;
				cursor: pointer;
				margin: 0 12px 15px 12px;

				.recruitmentBottomBox {
					overflow: hidden;
					padding: 10px 12px 0 12px;
					width: 100%;
					color: #333;
					font-size: 14px;
					text-align: center;

					.recruitmentBottomTopBox {
						width: 44px;
						height: 44px;
						margin: 10px auto;
						border: 1px solid #dedede;

						img {
							width: 100%;
							height: 100%;
							object-fit: cover;
						}
					}

					.recruitmentBottomMiddleBox {
						padding: 12px 0;
					}

					.recruitmentBottomBottomBox {
						padding: 8px 0;
						color: #999;
						min-height: 58px;
					}

					.recruitmentBottomBoxBtn {
						width: 100px;
						height: 30px;
						margin: 15px auto 20px auto;

						.btn {
							width: 100%;
							height: 100%;
						}
					}
				}
			}

			.recruitmentSmallInfo:hover {
				border: none;
				-webkit-transition: all 0.3s ease 0s;
				transition: all 0.3s ease 0s;
				//border: 1px solid #ffffff;
				cursor: pointer;
				-webkit-box-shadow: 0 5px 10px 1px #d2e6ff;
				box-shadow: 0 5px 10px 1px #d2e6ff;
			}
		}
	}
}

.talentBox {
	overflow: hidden;
	width: 1200px;
	margin: 20px auto;

	.talentLeftBox {
		float: left;
		width: 70%;

		.talentTitleBox {
			overflow: hidden;
			width: 100%;
			padding: 15px 0 8px 0;
			border-bottom: 1px solid #dedede;

			.talentTitle {
				float: left;
				font-size: 20px;
				color: #333;
			}

			.talentTitle::before {
				content: '';
				padding-left: 12px;
				border-left: 4px solid #035aea;
			}

			.MoreBox {
				float: right;
				color: #999;
				font-size: 14px;
				cursor: pointer;
			}
		}

		.talentContentBox {
			padding: 14px 0;
			width: 100%;

			.talentSmallBox {
				overflow: hidden;
				padding: 10px 0;

				.talentSmallLeft {
					float: left;
					width: 34%;
					height: 400px;

					img {
						width: 100%;
						height: 100%;
					}
				}

				.talentSmallright {
					float: right;
					width: 65%;

					.talentSmallContent {
						display: flex;
						justify-content: space-between;
						flex-wrap: wrap;

						.card {
							width: 49%;
							padding: 10px;
							border: 1px solid #dedede;
							cursor: pointer;
							margin-bottom: 30px;

							.titleName {
								padding: 10px 0;
								font-size: 18px;
								color: #333;
							}

							.info {
								// padding: 10px 0;
								font-size: 14px;
								color: #666;

								p {
									padding-bottom: 10px;
								}
							}

							&:nth-child(3) {
								margin-bottom: 0;
							}

							&:nth-child(4) {
								margin-bottom: 0;
							}
						}

						.card:hover {
							border: none;
							-webkit-transition: all 0.3s ease 0s;
							transition: all 0.3s ease 0s;
							//border: 1px solid #ffffff;
							cursor: pointer;
							-webkit-box-shadow: 0 5px 10px 1px #d2e6ff;
							box-shadow: 0 5px 10px 1px #d2e6ff;
						}

						.talentSmallItem {
							margin-bottom: 16px;
							border: 1px solid #dedede;
							padding: 12px 0;
							width: 49%;
							cursor: pointer;

							.talentInfo {
								padding: 0 15px;
								font-size: 14px;
								color: #333;
								font-family: '微软雅黑';

								.name {
									padding-bottom: 15px;
									font-size: 16px;
									color: #333;
									font-weight: bold;
								}

								.qualification {
									width: 100%;
									padding: 3px 0;
									font-size: 14px;
									color: #666;
									text-overflow: ellipsis;
									-o-text-overflow: ellipsis;
									overflow: hidden;
									white-space: nowrap;
								}
							}

							.position {
								padding: 4px 10px;
								font-weight: bold;
								font-family: '微软雅黑';
								font-size: 30px;
								color: #ff9000;
							}
						}

						.talentSmallItem:hover {
							border: none;
							-webkit-transition: all 0.3s ease 0s;
							transition: all 0.3s ease 0s;
							//border: 1px solid #ffffff;
							cursor: pointer;
							-webkit-box-shadow: 0 5px 10px 1px #d2e6ff;
							box-shadow: 0 5px 10px 1px #d2e6ff;
						}
					}
				}
			}
		}
	}

	.talentRightBox {
		float: right;
		width: 28%;

		.talentTitleBox {
			overflow: hidden;
			width: 100%;
			padding: 15px 0 8px 0;
			border-bottom: 1px solid #dedede;

			.talentTitle {
				float: left;
				font-size: 20px;
				color: #333;
			}

			.talentTitle::before {
				content: '';
				padding-left: 12px;
				border-left: 4px solid #035aea;
			}

			.MoreBox {
				float: right;
				color: #999;
				font-size: 14px;
				cursor: pointer;
			}
		}

		.talentContentBox {
			padding: 14px 10px;
			width: 100%;

			.talentSmallBox {
				position: relative;
				padding: 10px 0;
				border-bottom: 1px dashed #dedede;

				.teacherName {
					font-size: 16px;
					color: #333;
				}

				.teacherInfo {
					width: 100%;
					font-size: 14px;
					color: #999;

					.teacherResearch {
						width: 69%;
						text-overflow: ellipsis;
						-o-text-overflow: ellipsis;
						overflow: hidden;
						white-space: nowrap;
					}
				}

				.askBtn {
					position: absolute;
					top: 18%;
					right: 1%;
				}
			}
		}
	}
}

.linkBox {
	overflow: hidden;
	margin: 20px auto 0 auto;
	width: 1200px;

	.linkLeft {
		float: left;
		width: 7%;
		font-size: 20px;
		color: #333;
		line-height: 82px;
	}

	.linkRight {
		float: right;
		width: 90%;
		overflow: hidden;
		padding: 30px 0;
		// display: flex;
		// justify-content: space-around;
		// flex-wrap: wrap;

		.linkRightItem {
			width: 15%;
			color: #333;
			font-size: 14px;
			text-align: center;
			float: left;
		}
	}
}

.ant-btn-background-ghost.ant-btn-primary {
	color: #FFFFFF;
	background-color: #035aea;
}
</style>
